import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IMediclaim } from "./imediclaim";


@Injectable({ providedIn: 'root' })
export class MediclaimService {

    private _mediclaim: BehaviorSubject<IMediclaim | null> = new BehaviorSubject<IMediclaim | null>(null);
    private _mediclaims: BehaviorSubject<IMediclaim[]> = new BehaviorSubject<IMediclaim[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get mediclaim$(): Observable<IMediclaim | null> {
        return this._mediclaim.asObservable();
    }

    get mediclaims$(): Observable<IMediclaim[]> {
        return this._mediclaims.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }



    getMediclaimPlan(mediclaimdata: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; mediclaims: IMediclaim[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; mediclaims: IMediclaim[] }>>(`${environment.baseURl}/MediclaimPlan/list`, mediclaimdata).pipe(
            tap((response) => {

                this._pagination.next(response.result.pagination);
                this._mediclaims.next(response.result.mediclaims);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createMediclaim(Mediclaim: IMediclaim): Observable<BaseRespone<IMediclaim>> {
        return this._httpClient.post<BaseRespone<IMediclaim>>(`${environment.baseURl}/MediclaimPlan`, Mediclaim)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteMediclaim(id: number): Observable<BaseRespone<boolean>> {
        return this.mediclaims$.pipe(
            take(1),
            switchMap(Mediclaim =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/MediclaimPlan/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = Mediclaim.filter(item => item.id !== id);
                            this._mediclaims.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateMediclaim(mediclaim: IMediclaim): Observable<BaseRespone<IMediclaim>> {
        return this.mediclaims$.pipe(
            take(1),
            switchMap(mediclaims => this._httpClient.put<BaseRespone<IMediclaim>>(`${environment.baseURl}/MediclaimPlan`, mediclaim).pipe(
                map((updated: BaseRespone<IMediclaim>) => {

                    // Find the index of the updated product
                    const index = mediclaims.findIndex(item => item.id === mediclaim.id);

                    // Update the product
                    mediclaims[index] = mediclaim;

                    // Update the products
                    this._mediclaims.next(mediclaims);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                return of(error.error);
            })
        );
    }


}